const layoutAsideLeft = '[data-layout*="aside-left"]'
const asideLeft = '[data-aside="left"]'
const asideFooter = '[data-abide-footer]'
const asideAnimation = '[data-aside-animation]'
const asideStartWidth = 260
const asideEndWidth = 64
const asideDuration = 200
const asideInstruction = '[data-instruction]'

if (localStorage.getItem('layoutStyle') === 'aside-close') {
	$(layoutAsideLeft).addClass('is_close').css('--layout_aside_left_w', `${ asideEndWidth }px`)
	$(asideLeft).addClass('is_close')
	$(root).addClass('trs0s')
	setTimeout(function () {
		$(root).removeClass('trs0s')
	}, 500)
}

$(document)
	.on('click', '[data-aside-btn="toggle"]', function (e) {
		e.preventDefault()

		localStorage.layoutStyle = 'aside-close'
		if ($(asideLeft).hasClass('is_close')) {
			localStorage.layoutStyle = ''
			$(asideAnimation).animate({ width: asideStartWidth }, {
				duration: asideDuration,
				step(now) {
					$(layoutAsideLeft).css('--layout_aside_left_w', `${ now }px`);
				}
			})
			$(asideInstruction).fadeIn(asideDuration)
		} else {
			$(root).addClass('trs0s')

			$(asideAnimation).animate({ width: asideEndWidth }, {
				duration: asideDuration,
				step(now) {
					$(layoutAsideLeft).css('--layout_aside_left_w', `${ now }px`);
				},
				complete() {
					$(root).removeClass('trs0s')
				}
			})
			$(asideInstruction).fadeOut(0)
		}
		$(asideLeft).toggleClass('is_close')
		$(layoutAsideLeft).toggleClass('is_close')
	})

$(window).resize(() => {
	if (window.matchMedia('(min-width: 280px) and (max-width: 1434.7px)').matches) {
		$(layoutAsideLeft).addClass('is_mobile')
		$(asideLeft).addClass('is_mobile')
		$(root).addClass('trs0s')
		setTimeout(function () {
			$(root).removeClass('trs0s')
		}, 500)
	}
	if (window.matchMedia('(min-width: 1435px)').matches) {
		$(layoutAsideLeft).removeClass('is_mobile')
		$(asideLeft).removeClass('is_mobile')
	}
	$(asideFooter).css('max-height', `calc(var(--viewportHeight, 100vh) - ${ $(asideFooter).offset()?.top }px - (24px - var(--offset-top, 0px)))`)
})


